<div class="filter-box" (mouseleave)="closeFilter()"
        [ngClass]="{'active': showFilter}" 
        [style.left.px]="pos.pageX" 
        [style.top.px]="pos.pageY">
    <div class="lst-button-sort" *ngIf="status === '1' || status === '2'">
        <button (click)="getSortBy('asc', sltdId, sltdField)" [ngClass]="{'active': sortFlag === 'asc'}">Sort Asc</button>
        <button (click)="getSortBy('desc', sltdId, sltdField)" [ngClass]="{'active': sortFlag === 'desc'}">Sort Desc</button>
    </div>
    <div class="selectBox" *ngIf="status === '1' || status === '3'">
        <div class="inp-search-filter">
            <input type="text" [(ngModel)]="keySrh" (keyup)="filter(keySrh)" class="form-control">
        </div>
        <div class="lstItem-filter" *ngFor="let item of colSltedFilter">
            <div>
                <label class="custom-checkbox">
                    <ng-container *ngIf="item.name === 'iconYellow'">
                        <app-icon-warning style="color: #fdec96" [(icon)]="item.lstCode[0]"></app-icon-warning>
                    </ng-container>
                    <ng-container *ngIf="item.name === 'iconWarning'">
                        <span class="icon-img icon-attention active"></span>
                    </ng-container>
                    <ng-container *ngIf="item.name === 'iconNote'">
                        <span class="icon-img icon-remarks active"></span>
                    </ng-container>
                    <ng-container *ngIf="item.name === 'iconCheck'">
                        <svg style="color: green;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                        </svg>
                    </ng-container>
                    <ng-container *ngIf="item.name !== 'iconYellow' && item.name !== 'iconWarning' && item.name !== 'iconNote' && item.name !== 'iconCheck'">
                        {{item.name}}
                    </ng-container>
                    <input type="checkbox" [disabled]="filterFlag && item.IsShow" (click)="checkFilter(item)" [(ngModel)]="item.IsShow"/>
                    <span class="checkmark"></span>
                </label>
            </div>
        </div>
    </div>
  </div>